import pick from 'lodash/pick';
export var ColorVariant;
(function (ColorVariant) {
    ColorVariant["White"] = "white";
    ColorVariant["WhiteLink"] = "white-link";
    ColorVariant["Gray"] = "gray";
    ColorVariant["Blue"] = "blue";
    ColorVariant["Orange"] = "orange";
    ColorVariant["Yellow"] = "yellow";
    ColorVariant["Red"] = "red";
    ColorVariant["Purple"] = "purple";
    ColorVariant["Turquoise"] = "turquoise";
    ColorVariant["Green"] = "green";
    ColorVariant["Transparent"] = "transparent";
    ColorVariant["LightPurple"] = "light-purple";
    ColorVariant["LightOrange"] = "light-orange";
    ColorVariant["LightTurquoise"] = "light-turquoise";
    ColorVariant["Promo2"] = "promo-2";
    ColorVariant["PrimaryBg"] = "primary-bg";
})(ColorVariant || (ColorVariant = {}));
export const MarkdownColorVariant = pick(ColorVariant, ['White', 'WhiteLink', 'Blue', 'Gray', 'LightPurple', 'Purple']);
export const SimpleColorVariant = pick(ColorVariant, ['White', 'Gray']);
export const BackgroundColorVariant = pick(ColorVariant, ['White', 'Gray', 'Blue', 'LightPurple', 'Purple']);
export const BackgroundColorVariantWithTransparent = pick(ColorVariant, ['White', 'Gray', 'Blue', 'Transparent']);
export const ExtendedColorVariant = pick(ColorVariant, [
    'White',
    'Gray',
    'Blue',
    'Orange',
    'Yellow',
    'Red',
    'Purple',
    'Turquoise',
    'LightPurple',
    'LightOrange',
    'LightTurquoise',
    'Promo2',
    'PrimaryBg',
]);
export const BadgeColorVariant = pick(ColorVariant, [
    'White',
    'Gray',
    'Blue',
    'Orange',
    'Yellow',
    'Red',
    'Purple',
    'Turquoise',
    'Green',
]);
export function invertSimpleColorVariant(variant) {
    if (variant === SimpleColorVariant.White) {
        return SimpleColorVariant.Gray;
    }
    return SimpleColorVariant.White;
}
export function isColorVariantDark(colorVariant) {
    switch (colorVariant) {
        case ExtendedColorVariant.Blue:
        case ExtendedColorVariant.Orange:
        case ExtendedColorVariant.Turquoise:
        case ExtendedColorVariant.Purple:
            return true;
        default:
            return false;
    }
}
//# sourceMappingURL=color-variant.js.map